import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { MessengerTabsData } from "../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setMessengerActiveTab } from "../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import SvgIcon from "../../../CommonComponents/SvgIcon";
import ChatTab from "./ChatTab";
import ChatTitle from "./ChatTitle";
import CallTab from "./CallTab";
import ContactTab from "./ContactTab";

const ChatSection = () => {
  const dispatch = useAppDispatch();
  const { messengerActiveTab } = useAppSelector((state) => state.messenger);
  return (
    <div className="chat custom-scroll">
      <ChatTitle />
      <div className="template-tab tab-sm chat-tabs">
        <Nav tabs>
          {MessengerTabsData.map((item, index) => (
            <NavItem key={index}>
              <NavLink className={`button-effect ${item.class} ${messengerActiveTab === item.type ? "active" : ""}`} onClick={() => dispatch(setMessengerActiveTab(item.type))}>
                <SvgIcon className="fill-white" iconId={item.icon} />
                {item.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={messengerActiveTab}>
          <TabPane tabId="chat">
            <ChatTab />
          </TabPane>
          <TabPane tabId="call">
            <CallTab />
          </TabPane>
          <TabPane tabId="contact">
            <ContactTab />
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default ChatSection;
